import { EntityWithId, StrapiMediaInfo } from 'apolloClient/types';
import Image from 'next/legacy/image';
import React from 'react';

import {
  getOriginalImageUrlFromImage,
  getActualImageFormat,
} from 'lib/getImages';

import { PageBuilderImageType } from '../PageBuilderContentParser';
import { defaultImage } from 'src/constants/constants';

interface PageBuilderImageTypes {
  styles: React.CSSProperties;
  image: PageBuilderImageType;
  caption?: string;
  captionLink?: string;
}

type ImageAdditionalProps = {
  src: string;
  blurDataURL: string;
  width: number;
  height: number;
};

function getImageProps(image: StrapiMediaInfo): ImageAdditionalProps {
  const imageUrl = getOriginalImageUrlFromImage(image);
  const mediumImageFormat = image.formats?.medium || image;
  const blurDataURL = defaultImage;

  if (imageUrl) {
    return {
      src: imageUrl,
      width: mediumImageFormat?.width,
      height: mediumImageFormat?.height,
      blurDataURL,
    };
  }

  return {
    src: image?.url,
    width: image?.width,
    height: image?.height,
    blurDataURL,
  };
}

const PageBuilderImage: React.FC<PageBuilderImageTypes> = ({
  styles,
  image,
  caption,
  captionLink,
}) => {
  if (!image) return null;

  return (
    <div
      className="page-builder-image relative w-full h-full"
      data-pb-type="Image"
      style={{ ...styles, width: '100%' }}
    >
      <div className="relative w-full h-full ">
        <img
          src={getImageProps(image).src}
          alt="image"
          className="mx-auto max-h-[80vh] w-auto h-auto object-contain"
          style={{ ...styles }}
        />
      </div>
      {caption && (
        <div
          className="caption-wrapper"
          style={{
            justifyContent: styles.justifyContent,
            alignItems: styles.alignItems,
          }}
        >
          {!!captionLink ? (
            <a
              target="_blank"
              href={captionLink}
              className="caption"
              style={{
                fontSize: styles.fontSize,
                fontWeight: styles.fontWeight,
                color: styles.color,
              }}
              rel="noopener noreferrer"
            >
              {caption}
            </a>
          ) : (
            <p
              className="caption"
              style={{
                fontSize: styles.fontSize,
                fontWeight: styles.fontWeight,
                color: styles.color,
              }}
            >
              {caption}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default PageBuilderImage;
